import React from "react";
import ArticleCardCategoryBG from "./ArticleCardCategoryBG.svg";
import Share from "./share.svg";
import Comment from "./comment.svg";

export const ArticleCard = ({
  className,
  thumb,
  title,
  description,
  category,
  date,
  viewMoreLabel,
}) => {
  return (
    <div className={`article-card ${className} text-left`}>
      <div className="article-card__border">
        <img
          className="article-card__thumb img-fluid w-100"
          src={thumb}
          alt={title}
          title={title}
        />

        <div className="article-card__text position-relative">
          <div className="article-card__category position-absolute">
            <strong>{category}</strong>
            <img src={ArticleCardCategoryBG} alt={title} />
          </div>

          <h4 className="article-card__title">{title}</h4>

          <p className="article-card__description">
            {description} <strong className="view-more">{viewMoreLabel}</strong>
          </p>
          <div className="article-card__footer d-flex flex-wrap align-items-center justify-content-between mt-5">
            <span>{date}</span>
            <div className="article-card__actions d-flex align-items-center">
              <img src={Share} alt="Share" />
              <div>
                <img src={Comment} alt="Comment" />
                <small>25</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
